import { css } from "@emotion/css";
import {palette as palette2} from 'Shared/artists/Palette';
import { sanitise } from 'Shared/common/Sanitise';


/* Palette */
function palette() 
{
	return {
		background: 'grey',
		dimBackground: '#f5f5f5',   //XXX alt name - could be 'shaded'
		frontendBackground: 'black', //CJ added because we need poster previews to be viewed in context of the frontend background
		text: 'black', 
		dimText: '#aaa',		// e.g. disabled

		borderBackgroundColour: '#1b2126',

		subHeaderBackground: '#fafafa',

		label: '#666',

		//XXX cf relationship with IconColour
		active: '#44C4A1',
		inactive: 'lightgrey',

		link: '#005394',
		error: '#ff0101'
	};
}

export function sizes() 
{
	return {
		mobile: 600,
		endFontShrink: 375,
		minDesktopWidth: 1000,
		maxBodyWidth:  1100
	};
}

function button()  
{
	return {
		textAlign: 'center',
		verticalAlign: 'middle',
		backgroundColor: palette2.button,
	//	backgroundColor: '#7e94a5',
		borderRadius: 3,
		border: '1px solid #728a9d',
		color: '#FFF',
		padding: '8px 12px',
		fontSize: 13,
		fontWeight: 400,
		lineHeight: '16px',
		userSelect: 'none',
		whiteSpace: 'noWrap',

		'&:hover': {
			cursor: 'pointer',

			backgroundColor: '#627b8e',
			borderColor: '#566b7c',
		},

		'&[disabled]': {
			filter: 'brightness(125%)',

			'&:hover': {
				cursor: 'not-allowed'
			}
		},

		'&:focus': {
			border: `solid 1px brightness(70%)`
		}
	};
}


export function backendTheme()  //XXX should implement ITheme, but having trouble 
{
	return {
		palette: palette(),
		sizes: sizes(),
		//TODO
		//fonts:fonts,

		root: {
			font: '15px "Open Sans",Helvetica,Arial,sans-serif',
			backgroundColor: 'white',
			color: 'black'
		},

		nav: {
			height: '70px'
		},

		content: {
			paddingTop: '2em'
		},

		heading: {
			color: 'black',
			fontWeight: 600
		},

		inverseHeading: {
			margin: '1em 1em 1em 0',

			select: {
				fontSize: '1.1em',
				background: '#1b2126',
				color: 'white !important',
				border: 'none'
			}
		},

		fieldWrap: {
			display: 'block',
			marginBottom: 15,
			width: '100%',
			padding: 6
		},

	//	'button, input[type="submit"], input[type="button"]': {
		button: button(),

		smallButton: {...button(),
			padding: '6px 0.6em',
			fontSize: '0.7em'
		},

		a: {
			...sanitise.a,
			color: palette().link,
			cursor: 'pointer',

			'&:visited': {
				color: palette().link
			}
		},

		section: {
	//XXX I suspect the blue on is really the main case, and the other one an exception. cf renaming
			blueHeading: {
				fontSize: '1.2em',
				color: '#42627b',
				lineHeight: '1.5em',
				textTransform: 'uppercase',
				textAlign: 'left',
				fontWeight: 'initial'
			},

			heading: {
				color: 'black',
				textTransform: 'uppercase',
				fontSize: 15,
				fontWeight: 600,
				margin: '12px 0'
			},
		},

		menu: {
			heading: {
				fontSize: '1.1em',
				fontWeight: 'normal',
				margin: '2em 0 1em 0',
				color: '#7e94a5'
			}
		},

		detailsPane: {
			border: '1px solid #eee',
			borderBottom: 'none',
			padding: '1em 1em 0 1em',
			minHeight: 315,
			/* Allow the active tab to cut of hole in the bottom border */ 
			zIndex: -1
		},

		linkIcon: {
			width: '2em'
		},

		warning: {
			color: palette().error
		}
	};
}

export function verticalStyle(gap='1em') 
{
	return css({
		display: 'flex',
		flexDirection: 'column',
		gap: gap
	});
}

export function inlineOpenLinkStyle() 
{
	return css(backendTheme().a, {
		display: 'inline-flex',
		alignItems: 'center',
		gap: '0.5em',
	//	padding: '0 0.6em'
	});
}

